import { _inp, Inp } from '../../components/ui/Inputs.jsx';
import { DELAIS_PROPOSES, delaiSaisi, libelleDelai } from '../../lib/echeances';

/**
 * Délai de paiement convenu avec un client, en liste fermée comme dans la
 * maquette V288 : « Par défaut », 15, 30, 45 ou 60 jours, ou à réception.
 *
 * Un délai saisi librement avant la liste fermée (20 jours, par exemple)
 * reste proposé tel quel, marqué « valeur existante » : le client garde
 * l'accord qu'il avait, et le choisir à nouveau ne le change pas.
 *
 * @param {object} props propriétés du composant
 * @param {number|string} props.value délai enregistré, `''` pour celui de la
 *   maison
 * @param {(delai: number|'') => void} props.onChange reçoit le délai choisi
 * @returns {import('react').ReactElement} la liste des délais
 */
export function ChoixDelaiPaiement({ value, onChange }) {
  const actuel = delaiSaisi(value);
  const horsListe = actuel !== '' && !DELAIS_PROPOSES.includes(actuel);
  return (
    <Inp label="Délai de paiement — échéance des factures de ce client">
      <select
        aria-label="Délai de paiement"
        value={actuel === '' ? '' : String(actuel)}
        onChange={(e) => onChange(delaiSaisi(e.target.value))}
        style={{ ..._inp, background: '#fff' }}
      >
        <option value="">Par défaut</option>
        {DELAIS_PROPOSES.map((jours) => (
          <option key={jours} value={String(jours)}>
            {libelleDelai(jours)}
          </option>
        ))}
        {horsListe && (
          <option value={String(actuel)}>{libelleDelai(actuel)} (valeur existante)</option>
        )}
      </select>
    </Inp>
  );
}
